"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _lodash = require("lodash");
var DeviceCollection = {
  devices: {},
  get: function get(deviceId) {
    return this.devices[deviceId];
  },
  set: function set(device) {
    var deviceId = device.id || device.identity && device.identity.id;
    // check if the device is already existing, if so then merge else add
    var existingDevice = this.devices[deviceId];
    if (existingDevice) {
      // already existing, merge for any new binding information
      (0, _lodash.merge)(existingDevice, device);
    } else {
      this.devices[deviceId] = device;
    }
  },
  reset: function reset() {
    this.devices = {};
  },
  getAll: function getAll() {
    return (0, _values.default)(this.devices);
  }
};
var _default = exports.default = DeviceCollection;
//# sourceMappingURL=collection.js.map
